export class HttpUtils
{
    static async ProcessFetchResultAsync(result: Response)
    {
        if (!result.ok)
        {
            const errorData = await result.json().catch(() => ({}));

            let errorMessage;

            if (result.status == 405)
            {
                errorMessage = 'The requested method is not allowed.';
            }
            else
            {
                if (Array.isArray(errorData)) errorMessage = errorData.join(', ')
                else errorMessage = errorData.message ?? errorData.title;
            }

            throw new Error(errorMessage);
        }
    }
}
